<p class="mb-2">{{label}}</p>
<mat-form-field appearance="outline" class="doc-custom-input" [style.width]="width">
    <mat-select [value]="value" (selectionChange)="selectionChanged($event)" [disabled]="disabled">
        <mat-option *ngFor="let option of options" [value]="option.value">{{option.key}}</mat-option>
    </mat-select>
    <mat-hint>
        <doc-form-field-error [parentForm]="parentForm" [controlName]="controlName"></doc-form-field-error>
    </mat-hint>
</mat-form-field>